module.exports = __webpack_public_path__ + "static/media/summer-bum-text-ru.9350ff94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/summer-bum/summer-bum-text-ru.svg
// module id = 2472
// module chunks = 7